import { Box, Grid, Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppSettings } from '@/appSettings'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { usePartner } from '@/context/PartnerContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'

const baseUrl = AppSettings.baseUrl + '/docs/'

// Pouze Essox
export const WorkGuidelines = () => {
  const { currentPartner } = usePartner()
  const navigate = useNavigate()

  useEffect(() => {
    if (currentPartner?.partner !== 'Essox')
      navigate('/')
  }, [currentPartner?.partner])

  return (currentPartner?.partner === 'Essox' &&
        <PageWrapper
          header={<DashboardHeader title={(
            <>
              <Stack color='white' alignItems='center'>
                <Box>Pracovní směrnice</Box>
              </Stack>
            </>
          )}
          />}
          mainProps={{ sx: { pt: 8, gap: 4, display: 'grid' } }}
        >
          <Grid
            gap={8}
            sx={{
              backgroundColor: 'white',
              p: 6
            }}
            templateColumns={{base: '1fr', md: '1fr 1fr'}}
          >
            <DocumentsList items={[
              {
                url: baseUrl + 'essox/PS_2019-05_Odborna_zpusobilost_a_duveryhodnost.pdf',
                name: 'PS-2019/05 Odborná způsobilost a důvěryhodnost',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-06_Pravidla_kontroly.pdf',
                name: 'PS-2019/06 Pravidla kontroly',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-06_Priloha_1_Smlouva_VZOR.pdf',
                name: 'PS-2019/06 Příloha č. 1 - Vzor smlouvy',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-06_Priloha_2_Duveryhodnost_FO.pdf',
                name: 'PS-2019/06 Příloha č. 2 - Doklad k posouzení důvěryhodnosti (FO)',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-06_Priloha_3_Duveryhodnost_PO.pdf',
                name: 'PS-2019/06 Příloha č. 3 - Doklad k posouzení důvěryhodnosti (PO)',
                documentType: 'pdf'
              }
            ]} />
            <DocumentsList items={[
              {
                url: baseUrl + 'essox/PS_2019-07_Pravidla_odmenovani.pdf',
                name: 'PS-2019/07 Pravidla odměňování',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-08_Pravidla_obchodniho_jednani.pdf',
                name: 'PS-2019/08 Pravidla obchodního jednání',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-09_Stiznosti_a_reklamace_klientu.pdf',
                name: 'PS-2019/09 Stížnosti a reklamace klientů',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-10_Stret_zajmu.pdf',
                name: 'PS-2019/10 Střet zájmů',
                documentType: 'pdf'
              },
              {
                url: baseUrl + 'essox/PS_2019-11_Pravidla_komunikace_podle_ZoDP.pdf',
                name: 'PS-2019/11 Pravidla komunikace podle ZoDP',
                documentType: 'pdf'
              }]} />
          </Grid>
        </PageWrapper >
  )
}